import { atom } from 'jotai';
import {
  filterCollectionInputState,
  filterCollectionXclusionState,
  filterCreatorInputState,
  filterCreatorXclusionState,
  filterLanguageInputState,
  filterLanguageXclusionState,
  filterProductExactInputState,
  filterProductExactXclusionState,
  filterProductSimilarInputState,
  filterProductSimilarXclusionState,
  filterSourceInputState,
  allCollectionState,
  allProductState,
  FilterState,
  filterOwnContentInputState,
  filterOwnContentXclusionState,
  filterProductCatalogCountriesInputState,
  filterCreatorCountriesInputState,
  filterCreatorCountriesXclusionState,
} from '@src/pages/Discover/components/Atoms/Atoms';
import { DiscoverQs } from '@src/types/Discover';

const asBooleanXclusion = (xclusion: string) => xclusion === 'exclusion';

export const productExactExcludeState = atom((get) => asBooleanXclusion(get(filterProductExactXclusionState)));

export const productExactInput = atom((get) => get(filterProductExactInputState));

export const productSimilarExcludeState = atom((get) => asBooleanXclusion(get(filterProductSimilarXclusionState)));

export const productSimilarInput = atom((get) => get(filterProductSimilarInputState));

export const languageInput = atom((get) => get(filterLanguageInputState));

export const languageExcludeState = atom((get) => asBooleanXclusion(get(filterLanguageXclusionState)));

export const creatorInput = atom((get) => get(filterCreatorInputState));

export const creatorExcludeState = atom((get) => asBooleanXclusion(get(filterCreatorXclusionState)));

export const ownContentInput = atom((get) => get(filterOwnContentInputState));

export const ownContentExcludeState = atom((get) => asBooleanXclusion(get(filterOwnContentXclusionState)));

export const productCatalogCountriesInput = atom((get) => get(filterProductCatalogCountriesInputState));

export const creatorCountriesInput = atom((get) => get(filterCreatorCountriesInputState));

export const creatorCountriesExcludeState = atom((get) => asBooleanXclusion(get(filterCreatorCountriesXclusionState)));

export const collectionInput = atom((get) => get(filterCollectionInputState));

export const collectionExcludeState = atom((get) => asBooleanXclusion(get(filterCollectionXclusionState)));

export const sourceInput = atom((get) => get(filterSourceInputState));

export const allCollections = atom((get) => get(allCollectionState));

export const allProducts = atom((get) => get(allProductState));

export const getFilter = atom((get): DiscoverQs => get(FilterState));
